import { object } from 'yup';

import Step from './Step3';

export default {
  title: 'Extract',
  component: Step,
  validationSchema: () => object().shape({}),
};
